import NoImagesAvailableBanner from '@/../img/no-images-available.svg';
import styled from 'styled-components';

const Div = styled.div`
  min-width: 1000px;
  max-width: 1300px;
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
`;

const Text = styled.div`
  position: absolute;
  left: 30px;
  top: 220px;
  font-size: 22px;
  color: #9fa3af;
`;

interface Props {
  propertyAddress?: string;
}

export function NoImagesBanner(props: Props) {
  const ariaLabel = props.propertyAddress
    ? `No images available for ${props.propertyAddress}}`
    : 'No images available';

  return (
    <Div>
      <NoImagesAvailableBanner aria-label={ariaLabel} />
      <Text>No Images Available</Text>
    </Div>
  );
}
